import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        fsOfficers: false
      },
      options: {
        fsOfficers: []
      },
      selected: {
        fsOfficer: ''
      },
      editable: {
        fsOfficer: ''
      }
    }
  },

  methods: {

    async getFSOfficers (context, search = '', team = '', area = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.fsOfficer
      const fetching = context.fetching?.fsOfficers
      const options = context.options?.fsOfficers

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.fsOfficers = true
      context.selected.fsOfficer = ''

      const filters = {
        filter_text: search,
        team_id: team,
        area_id: area
      }

      return await SSharedList.getFSOfficers(filters).then(
        ({ data }) => {
          context.options.fsOfficers = data.map(
            fsOfficer => Object.assign(fsOfficer, {
              officer_name: `${fsOfficer.first_name} ${fsOfficer.last_name}`
            })
          )
        }
      ).catch(() => {
        context.options.fsOfficers = []
      }).finally(() => {
        context.fetching.fsOfficers = false
      })
    },

    async searchFSOfficers (search, loading) {
      this.searchFSOfficersProvider(this, search, loading)
    },

    searchFSOfficersProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.fsOfficers, {
          keys: ['officer_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            team_id: selected.team?.id || '',
            area_id: selected.area?.id || ''
          }

          SSharedList.getFSOfficers(filters).then(
            ({ data }) => {
              options.fsOfficers = data.map(
                fsOfficer => Object.assign(fsOfficer, {
                  officer_name: `${fsOfficer.first_name} ${fsOfficer.last_name}`
                })
              )
            }
          ).catch(() => {
            options.fsOfficers = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
